import './OrganizationDetails.scss';
import { Input } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { useOrganizationEditorStore } from 'stores/Admin/Editors/OrganizationEditorStore';

export const OrganizationDetails = () => {
  const {
    name,
    setName,
    numberOfLicensesToAdd,
    setNumberOfLicensesToAdd,
    numberOfInvites,
    setNumberOfInvites,
    membershipDurationMonth,
    setMembershipDurationMonth,
  } = useOrganizationEditorStore();

  return (
    <>
      <div className='admin-edit-section'>
        <h2>Organization name*</h2>
        <div className='inputs-container wide-input'>
          <Input
            label='Name'
            type='text'
            value={name ?? ''}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.currentTarget.value)}
          />
        </div>
      </div>
      <div className='admin-edit-section'>
        <div className='inputs-container'>
          <div className='input-wrapper'>
            <Paragraph>
              <>Number of licenses to add*</>
            </Paragraph>
            <Input
              label='Number of licenses'
              value={numberOfLicensesToAdd ?? ''}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                let licensesCount = e.currentTarget.value.replace(/[^0-9]/g, '');
                setNumberOfLicensesToAdd(licensesCount === '' ? null : licensesCount);
              }}
            />
          </div>
        </div>
        <Paragraph>
          <strong className='current-licenses-info'>Current number of licenses: {numberOfInvites}</strong>
        </Paragraph>
      </div>
      <div className='admin-edit-section'>
        <h2>Student duration (month)*</h2>
        <div className='inputs-container wide-input'>
          <Input
            label='Student duration'
            type='number'
            value={membershipDurationMonth.toString() ?? 0}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setMembershipDurationMonth(Number(e.currentTarget.value))}
          />
        </div>
        <Paragraph>
          <span className='required-info'>*required field</span>
        </Paragraph>
      </div>
    </>
  );
};
